const Spinner = () => (
  <span
    className="inline-block w-5 h-5 border-2 border-white border-t-transparent rounded-full animate-spin"
    aria-hidden="true"
  />
);

export default Spinner;